import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchDataForAuctionCalendarPage } from '@/redux/modules/auctionCalendar';
import { getSearchPageSize } from '@/redux/modules/pagination';
import { parseQueryParams } from '@/utils/queryParams';
import { recordAnalyticsForAuctionCalendarPageView } from '@/redux/modules/analytics';

export default ({ location, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const state = getState();
    const pageSize = getSearchPageSize(state);
    const queryParams: any = parseQueryParams(location.search);
    queryParams.pageSize = pageSize; // ignore pageSize in url

    return Promise.all([dispatch(fetchDataForAuctionCalendarPage(queryParams))]).then(() => {
        return dispatch(recordAnalyticsForAuctionCalendarPageView());
    });
};
